document.addEventListener("turbolinks:load", function() {
    const $bulkEditForm = $("#bulk-edit-form")
    if ($bulkEditForm.length === 0) return
    window.selectedAssignmentIds = new Set();
    // $(".bulk-edit-child-checkbox").on("change", function (){
    //     updateBulkButtons();
    // })
    //
    // $("#select-all-check").on("change", function(){
    //     updateBulkButtons();
    // })

    // update the checkbox to no longer have the previous group associated and have the new group associated.
    // update the old parent to no longer be checked off as necessary.
    window.updateCheckbox = (checkbox_id, data_group, old_parent) => {
        // get current checkbox
        const currentCheckbox = $(checkbox_id).find("input");
        // update the data group to match either the new group or set it null
        // If we are moving between folders this is set to the new groups folder
        // If we are moving out of a folder, this is set to null
        currentCheckbox.attr("data-group", data_group);
        // Just return out of the checkbox being moved is not checked
        if (!currentCheckbox.is(":checked")) return;
        // If we have a data group, then that means we are moving the item into a group
        if (data_group) {
            // Set the current parent checkbox of the group we are moving into
            const currentParent = $(`#${data_group}`).find(".bulk-edit-checkbox-parent");
            // Since we are a checkbox that is checked
            // we need to check if the current parent checkbox was already checked, if so return
            if (currentParent.is(":checked")) return;

            // if not we set it to indeterminate since we are now adding a checked checkbox
            currentParent.prop('indeterminate', true);
        } else if (old_parent) {
            // otherwise if we have an old parent, it implies that we have moved from some parent
            const oldParentEl = $(old_parent).find(".bulk-edit-checkbox-parent");
            // we need to check if the old parent had any checked and if not turn off the indeterminate checkbox
            if (oldParentEl && !parentAnyChecked($(old_parent))) {
                oldParentEl.prop('indeterminate', false);
            }
        }
    };

    window.updateEmptyFolder = (group_id, icon_replacement, replacement_type) => {
        if (replacement_type === "checkbox") {
            $(`#info_icon__empty-${group_id}`).replaceWith(icon_replacement)
        } else {
            $(`#AssignmentGroup_${group_id}`).find("label").replaceWith(icon_replacement)
            $(`#info_icon__empty-${group_id}`).popover()
        }
        
        if (bulkEditVisible()) {
            $(`#AssignmentGroup_${group_id}`).find(".bulk-edit-checkbox, .info_button_assignment_li").first().removeClass("invisible");
        }
    }

    const bulkEditVisible = () => {
        const bulkEditBarHidden = $(".bulk_edit_bar__content-options").hasClass("d-none");
        return !bulkEditBarHidden
    }

    const anyChecked = () => {
        return window.selectedAssignmentIds.size > 0;
    };

    const parentAnyChecked = (parent) => {
        return $(parent).find('.bulk-edit-checkbox:checked').length > 0;
    }

    const countChecked = () => {
        return window.selectedAssignmentIds.size
    }

    const handlerIn = (event) => {
        if (bulkEditVisible()) return false;

        $(event.currentTarget).find(".bulk-edit-checkbox, .info_button_assignment_li").first().removeClass("invisible");
    }

    const updateSelectionCount = () => {
        let numChecked = countChecked()
        if (numChecked > 1)
            $("#bulk-edit-selected-count").text(countChecked() + " Assignments Selected")
        else
            $("#bulk-edit-selected-count").text(countChecked() + " Assignment Selected")
    }

    const handlerOut = (event) => {
        if (bulkEditVisible()) return false;

        const checkbox = $(event.currentTarget).find(".bulk-edit-checkbox, .info_button_assignment_li").first();
        checkbox.addClass("invisible");
    }

    $("#bulk-edit-select-all").on("click", function (e) {
        e.preventDefault();
        selectAll()
    })

    $("#bulk-edit-close-button").on("click", function (e) {
        $('.bulk-edit-checkbox').prop('checked', false)
        $('.group-check').prop('indeterminate', false)
        bulkEditActive(false, e)
        window.selectedAssignmentIds = new Set();
        $bulkEditForm.find(".persisted-assignment").remove();
    })

    const selectAll = () => {
        $('.bulk-edit-checkbox').prop('checked', true)
        $('.bulk-edit-child-checkbox').each(function () {
            const assignmentId = $(this).val();
            window.selectedAssignmentIds.add(assignmentId);
        });
        updateSelectionCount();
    }

    window.bulkEditActive = (bulkEdit = false, event) => {
        const createDropdown = $(".assignments__create-dropdown-toggle, .assignments__create-button");
        const kebabMenus = $(".assignment-kebab-menu");
        const createFolder = $(".bulk_edit_bar__content-create_folder");
        const checkboxes = $(".bulk-edit-checkbox, .info_button_assignment_li");
        const bulkOptions = $(".bulk_edit_bar__content-options");
        const bulkEditBar = $(".bulk_edit_bar__content");
        const filterDropdown = $(".bulk_edit_bar__content-filter")
        const bulkEditStatus = $("#bulk-edit-status");

        if (bulkEdit) {
            createDropdown.addClass("disabled");
            kebabMenus.addClass("invisible");
            createFolder.addClass("d-none");
            checkboxes.removeClass("invisible");
            bulkOptions.removeClass("d-none");
            bulkEditBar.addClass("bulk_edit_bar__content-bordered")
            filterDropdown.addClass("d-none")
            updateSelectionCount();
            toggleBulkButtons(true);
            bulkEditStatus.text("Bulk Edit Mode On");
        } else {
            const currentCheckbox = $(event?.currentTarget);
            const currentParent = currentCheckbox?.closest(".assignment-group").find(".bulk-edit-checkbox-parent");
            createDropdown.removeClass("disabled");
            kebabMenus.removeClass("invisible");
            createFolder.removeClass("d-none");
            filterDropdown.removeClass("d-none")
            checkboxes.not(currentCheckbox).not(currentParent).addClass("invisible");
            bulkOptions.addClass("d-none");
            bulkEditBar.removeClass("bulk_edit_bar__content-bordered")
            toggleBulkButtons(false);
            bulkEditStatus.text("Bulk Edit Mode Off");
        }
    }

    $bulkEditForm.on("mouseenter", ".assignment-list-item, .assignment-group", handlerIn)
        .on("mouseleave", ".assignment-list-item, .assignment-group", handlerOut)
        .on("change", ".bulk-edit-child-checkbox, .bulk-edit-checkbox-parent", (event) => {
            const $target = $(event.currentTarget);
            const isChecked = $target.is(":checked");
            const group = $target.attr("data-group");

            if ($target.hasClass("bulk-edit-child-checkbox")) {
                const assignmentId = $target.val();
                checkboxCheckUpdate($target, isChecked, group)
                selectedAssignmentIdsUpdate(isChecked, assignmentId)
            } else {
                // Get all child check boxes with the same data-group
                $(`.child-check[data-group='${group}']`).each(function () {
                    $(this).prop('checked', isChecked)
                    const assignmentId = $(this).val();
                    selectedAssignmentIdsUpdate(isChecked, assignmentId)
                });
            }
                bulkEditActive(anyChecked(), event);
            })

    const selectedAssignmentIdsUpdate = (isChecked, assignmentId) => {
        if (isChecked) {
            window.selectedAssignmentIds.add(assignmentId);
        } else {
            window.selectedAssignmentIds.delete(assignmentId);
        }
    }

    const checkboxCheckUpdate = (target, isChecked, group) => {
        const parentSelector = ".group-check[data-group='" + group + "']"
        const childSelector = ".child-check[data-group='" + group + "'][value!='" + target.attr("value") + "']"

        if ($(parentSelector).prop('checked')) {
            // If the parent was checked, we need to uncheck it and check all its children except the one that was just clicked
            $(this).prop('checked', false)
            $(parentSelector).prop('checked', false)
            $(parentSelector).prop('indeterminate', $(childSelector).length > 0)
            $(childSelector).each(() => {
                $(this).prop('checked', true)
                $(this).prop('indeterminate', false)
            })
        } else {
            // Loop through all the other elements and check if there's any that don't match this one
            groupCheck(childSelector, parentSelector, isChecked, true)
        }
    }


    function resetActiveDropdownItems() {
        const activeDropdownItems = $(".bulk_edit_bar__content-filter-item-active");
        activeDropdownItems.removeClass("bulk_edit_bar__content-filter-item-active")
            .find(".bulk_edit_bar__content-filter-item_close").addClass("invisible");
    }
    function hidePill() {
        $("#vb_pill-assignment-filter-dropdown").addClass("d-none");
    }

    function showPill(text) {
        $("#vb_pill-assignment-filter-dropdown").removeClass("d-none").find(".vb_pill_text").text(text);
    }

    $(".bulk_edit_bar__content-filter-item_close").on("click", function(e) {
        e.stopPropagation(); // Prevents bubbling to parent
        resetActiveDropdownItems();
        hidePill();
        window.execute_live_search();
    });

    $(".bulk_edit_bar__content-filter-item").on("click", function(e) {
        const currentDropdownItem = $(e.currentTarget);
        const updateText = currentDropdownItem.attr("data-pill-text");
        resetActiveDropdownItems();
        showPill(updateText);
        currentDropdownItem.find(".bulk_edit_bar__content-filter-item_close").removeClass("invisible");
        currentDropdownItem.addClass("bulk_edit_bar__content-filter-item-active");
        window.execute_live_search();
    });

    $(".vb_pill_close-assignment-filter").on("click", function() {
        resetActiveDropdownItems();
        hidePill();
        window.execute_live_search();
    });
})

function updateBulkButtons(){
    let selectedBoxes = $(".child-check:checkbox:checked");
    let ltiLinkedCount = $(".child-check[data-lti-linked='true']:checkbox:checked").length
    let ltiLinkedUneditableCount = $(".child-check[data-lti-linked='true'][data-lti-link-editable='false']:checkbox:checked").length
    let totalCheckedCount = selectedBoxes.length
    toggleBulkButtons(totalCheckedCount > 0);

    if (ltiLinkedCount < totalCheckedCount){
        enablePublishDropdown()
    }else{
        disablePublishDropdown()
    }

    if (ltiLinkedUneditableCount >= ltiLinkedCount){
        disableLtiLinkOption()
    }
}

function disablePublishDropdown(){
    $("#bulk-publish-dropdown").addClass("disabled")
    $("#bulk-publish-dropdown").addClass("text-extra-muted")
    $("#bulk-publish-dropdown").addClass('no-hover-state')
}

function enablePublishDropdown(){
    $("#bulk-publish-dropdown").removeClass("disabled")
    $("#bulk-publish-dropdown").removeClass("text-extra-muted")
    $("#bulk-publish-dropdown").removeClass('no-hover-state')
}

function disableLtiLinkOption(){
    $("#lti-unlink").addClass('disabled')
    $("#lti-unlink").addClass('no-hover-state')
    $("#unlink-assignments").addClass('text-extra-muted')
    $("#unlink-assignments").removeClass('text-primary')
}

function toggleBulkButtons(enabled) {
    if (enabled){
        $(".bulk-edit-dropdown").removeClass('text-extra-muted')
        $('.bulk-edit-dropdown').removeClass('disabled')
        $('.bulk-edit-dropdown').removeClass('no-hover-state')
        $(".bulk-edit-link").removeClass('text-extra-muted')
        $(".bulk-edit-link").addClass('text-primary')
    } else {
        $(".bulk-edit-dropdown").addClass('text-extra-muted')
        $('.bulk-edit-dropdown').addClass('disabled')
        $('.bulk-edit-dropdown').addClass('no-hover-state')
        $(".bulk-edit-link").addClass('text-extra-muted')
        $(".bulk-edit-link").removeClass('text-primary')
    }
}

// Commenting out for now. If we ever return to trying to make bulk edit features disable based on data we should reimplement this
// .on("change", ".form-check-input", function (e) {
// const selectedBoxes = window.selectedAssignmentIds;
//
// // Toggle bulk buttons based on selection count
// if (selectedBoxes.size < 1) {
//     toggleBulkButtons(false);
// } else {
//     toggleBulkButtons(true);
// }

// Disable unlink button if any non-unlinkable items are selected
// if ($(".child-check[data-unlinkable='false']:checkbox:checked").length > 0) {
//     $("#lti-unlink").addClass("disabled");
// }

// Style unlink assignments as muted
// $("#unlink-assignments").addClass("text-extra-muted").removeClass("text-primary");
// $("#lti-unlink").addClass("no-hover-state");

// Handle publish dropdown state
// const nonPublishableChecked = $(".child-check[data-publishable='false']:checkbox:checked").length;
// const totalChecked = $(".child-check:checkbox:checked").length;
//
// if (nonPublishableChecked >= totalChecked) {
//     $("#bulk-publish-dropdown").addClass("disabled text-extra-muted no-hover-state");
// } else if (selectedBoxes.size > 0) {
//     $("#bulk-publish-dropdown").removeClass("disabled text-extra-muted no-hover-state");
// }
// });